import {Component, HostListener, OnInit} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {PassOnLog} from '../../../types/data.types';
import {PassOnLogService} from '../../../services/pass-on-log.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'view-pass-on-log-modal',
    templateUrl: './view-pass-on-log-modal.component.html',
    styleUrls: ['./view-pass-on-log-modal.component.scss']
})
export class ViewPassOnLogModalComponent implements OnInit {
    showModal = false;
    data: PassOnLog = new PassOnLog();

    constructor(
        public api: ApiClientService,
        public passOnLogService: PassOnLogService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.data = this.passOnLogService.passOnLogInPassOnLogModal;
    }

    hideModal() {
        this.passOnLogService.isViewPassOnLogModalShow = false;
        this.passOnLogService.passOnLogInPassOnLogModal = null;
        this.urlService.modalClosed.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/view-pass-on-log-modal/view-pass-on-log-modal.component.ts